import { useEffect, useRef, useState } from 'react'
import { ChevronDown } from 'lucide-react'

export default function DrawingTemplateMenu({ templates, kind, onSelect }) {
  const [open, setOpen] = useState(false)
  const root = useRef(null), trigger = useRef(null), menu = useRef(null)
  const rows = templates.filter(item => item.kind === kind).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true }))
  useEffect(() => {
    if (!open) return
    menu.current?.querySelector('button')?.focus()
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  const select = value => { setOpen(false); trigger.current?.focus(); onSelect(value) }
  return <div ref={root} className="relative">
    <button ref={trigger} type="button" aria-label="Drawing template" aria-haspopup="menu" aria-expanded={open}
      className="flex items-center gap-2 rounded-md border border-border bg-canvas px-2.5 py-1.5 text-xs text-ink hover:bg-canvas2"
      onClick={() => setOpen(value => !value)}>Template<ChevronDown size={12} strokeWidth={1.3} /></button>
    {open && <div ref={menu} role="menu" aria-label="Drawing templates" className="absolute bottom-full left-0 z-20 mb-1 max-h-64 w-60 overflow-auto rounded-lg border border-border bg-canvas p-1 text-xs text-ink shadow-lg"
      onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); setOpen(false); trigger.current?.focus() }
        if (event.key === 'Enter' || event.key === ' ') event.stopPropagation()
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault(); const items = [...menu.current.querySelectorAll('[role="menuitem"]')], index = items.indexOf(document.activeElement)
          items[event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length]?.focus()
        }
      }}>
      {[['save', 'Save as…'], ['defaults', 'Apply defaults']].map(([id, label]) => <button key={id} type="button" role="menuitem" className="block w-full rounded px-3 py-2 text-left hover:bg-canvas2 focus:bg-canvas2 focus:outline-none" onClick={() => select(id)}>{label}</button>)}
      {rows.length > 0 && <div role="separator" className="my-1 border-t border-border" />}
      {rows.map(item => <button key={item.id} type="button" role="menuitem" className="block w-full break-words rounded px-3 py-2 text-left hover:bg-canvas2 focus:bg-canvas2 focus:outline-none" onClick={() => select(item.id)}>{item.name}</button>)}
    </div>}
  </div>
}
